import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { ThemeToggle } from '@/components/theme-toggle'
import { MobileMenuButton } from '@/components/layout/sidebar'
import { useAuth } from '@/hooks/use-auth'
import { usePageContext } from '@/hooks/use-page-context'

export function Header() {
  const navigate = useNavigate()
  const { user, isLoading } = useAuth()
  const { pageInfo } = usePageContext()

  const defaultSubtitle = isLoading
    ? 'Carregando...'
    : user
      ? `Bem-vindo de volta, ${user.name}`
      : 'Bem-vindo'

  return (
    <header className='sticky top-0 z-30 flex h-16 items-center justify-between border-b border-border bg-background/95 px-4 backdrop-blur supports-[backdrop-filter]:bg-background/60 md:px-6'>
      <div className='flex items-center gap-3'>
        <MobileMenuButton />
        {pageInfo?.backPath && (
          <Button
            variant='ghost'
            size='icon'
            onClick={() => pageInfo?.backPath && navigate(pageInfo.backPath)}
            className='h-9 w-9'
          >
            <ArrowLeft className='h-5 w-5' />
          </Button>
        )}
        <div>
          <h1 className='text-xl font-bold text-foreground'>
            {pageInfo?.title || 'Painel de Controle'}
          </h1>
          <p className='text-sm text-muted-foreground'>{pageInfo?.subtitle || defaultSubtitle}</p>
        </div>
      </div>
      <div className='flex items-center gap-2'>
        <ThemeToggle />
      </div>
    </header>
  )
}
